import { z } from "zod";

const schema = z.object({
  VITE_WEB_URL: z.string().url(),
  VITE_ADDIN_URL: z.string().url(),
});

export const env = schema.parse({
  VITE_WEB_URL: import.meta.env.VITE_WEB_URL,
  VITE_ADDIN_URL: import.meta.env.VITE_ADDIN_URL,
});

export type AddinEnv = typeof env;
